module.exports = __webpack_public_path__ + "515fd07d517c5d8817164a65d81fd042.png";